import React from 'react';

interface Props {
    text: string;
    onClick?: () => void;
}

const ShowAllButton = ({ text, onClick }: Props) => {
    return (
        <button className="btn-more border-0 w-auto" onClick={onClick}>
            {text}
        </button>
    );
};

export default ShowAllButton;
